import { render, staticRenderFns } from "./BackInHistoryBtn.vue?vue&type=template&id=ad07a07c&scoped=true&"
import script from "./BackInHistoryBtn.vue?vue&type=script&lang=js&"
export * from "./BackInHistoryBtn.vue?vue&type=script&lang=js&"
import style0 from "./BackInHistoryBtn.vue?vue&type=style&index=0&id=ad07a07c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad07a07c",
  null
  
)

export default component.exports